/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import {useIntl} from 'react-intl';
import {SidebarMenuItem} from './SidebarMenuItem';
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub';
import SecuredComponent from '../../../../../app/modules/auth/authorization/SecuredComponent';
import {toAbsoluteUrl} from '../../../../helpers';
import {isClientCIS} from "../../../../../Domains/Auth/Utils/CustomerHelper";
import {useGetMe} from "../../../../../app/hooks/useGetMe";
import {useGetClientType} from "../../../../../app/hooks/useClientType";
import {isSidebarItemHiddenForClientType} from "../../../../../Domains/Auth/Config/SidebarVisibilityConfig";

const iconDashboard = toAbsoluteUrl('/assets/navIcons/Mon tableau de bord-1.png');
const iconMarketplace = toAbsoluteUrl('/assets/navIcons/caddie-17.png');

const MenuSeparator = () => (
  <div className="menu-item">
    <div className="menu-content">
      <div className="separator mx-1 my-1"></div>
    </div>
  </div>
);

const SidebarMenuMain = () => {
  const intl = useIntl();
  const customer = useGetMe();
  const {data: clientType} = useGetClientType();

  return (
    <>
      {/* Tableau de bord */}
      <SidebarMenuItem
        to="/dashboard"
        icon={iconDashboard}
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon=""
        hisPng={true}
      />

      <MenuSeparator />

      {/* Mon compte */}
      <SidebarMenuItemWithSub
        to="/orders"
        title={intl.formatMessage({id: 'MENU.MY_ACCOUNT'})}
        childPaths={['/documents', '/bills', '/mon-parc', '/my-account/contacts']}
        biIcon="bi-person-circle"
      >
        <SecuredComponent requiredPermissions={['voirSuiviCommande']}>
          <SidebarMenuItem
            to="/orders"
            title={intl.formatMessage({id: 'MENU.MY_ORDERS'})}
            hasBullet={true}
          />
        </SecuredComponent>
        <SecuredComponent requiredPermissions={['voirDocuments']}>
          <SidebarMenuItem
            to="/documents"
            title={intl.formatMessage({id: 'MENU.MY_DOCUMENTS'})}
            hasBullet={true}
          />
        </SecuredComponent>
        <SecuredComponent requiredPermissions={['voirDocuments', 'voirDocumentsRelationClient']}>
          <SidebarMenuItem
            to="/bills"
            title={intl.formatMessage({id: 'MENU.MY_BILLS'})}
            hasBullet={true}
          />
        </SecuredComponent>
        <SecuredComponent requiredPermissions={['voirEtatParc']}>
          <SidebarMenuItem
            to="/mon-parc"
            title={intl.formatMessage({id: 'MENU.MY_FLEET'})}
            hasBullet={true}
          />
        </SecuredComponent>
        {!isSidebarItemHiddenForClientType('divops', clientType) && (
          <SidebarMenuItem
            to="/my-account/contacts"
            title={intl.formatMessage({id: 'MENU.MY_CONTACTS'})}
            hasBullet={true}
          />
        )}
      </SidebarMenuItemWithSub>

      {/* Assistance & support */}
      <SidebarMenuItem
        to="/support-list"
        title={intl.formatMessage({id: 'MENU.SUPPORT'})}
        biIcon="bi-headset"
        activePaths={['/reclamations', '/support']}
      />

      <MenuSeparator />

      {/* Connexions */}
      <SecuredComponent requiredPermissions={['voirEtatParc']}>
        <SidebarMenuItemWithSub
          to="/services/connexion/liens"
          title={intl.formatMessage({id: 'MENU.CONNECTIONS'})}
          childPaths={['/configuration/routeurs-vpn', '/services/connexion/liens', '/services/connexion/vpn', '/services/consommationLTE','/services/monitoring']}
          biIcon="bi-diagram-3"
        >
          <SidebarMenuItem
            to="/services/connexion/liens"
            title={intl.formatMessage({id: 'MENU.CONNECTIONS.LINKS'})}
            hasBullet={true}
            activePaths={['/services/consommationLTE']}
          />
          <SecuredComponent requiredPermissions={['voirConfiguration']}>
            <SidebarMenuItem
              to="/services/connexion/vpn"
              title={intl.formatMessage({id: 'MENU.CONNECTIONS.VPN'})}
              hasBullet={true}
            />
          </SecuredComponent>
          <SecuredComponent requiredPermissions={['voirConfiguration']}>
            <SidebarMenuItem
              to="/configuration/routeurs-vpn"
              title={intl.formatMessage({id: 'MENU.CONFIGURATION'})}
              hasBullet={true}
            />
          </SecuredComponent>
          {isClientCIS(customer) &&
          <SecuredComponent requiredPermissions={['voirConfiguration']}>
            <SidebarMenuItem
                to="/services/monitoring"
                title={intl.formatMessage({id: 'MENU.MONITORING'})}
                hasBullet={true}
              />
          </SecuredComponent>
          }
        </SidebarMenuItemWithSub>
      </SecuredComponent>

      {/* Téléphonie */}
      <SecuredComponent requiredPermissions={['voirEtatParc']}>
        <SidebarMenuItemWithSub
          to="/services/telephonie/liste"
          title={intl.formatMessage({id: 'MENU.TELEPHONY.GROUP'})}
          childPaths={['/services/telephonie/liste', '/services/telephonie', '/services/telephonie/details-telephonie']}
          biIcon="bi-telephone"
        >
          <SidebarMenuItem
            to="/services/telephonie/liste"
            title={intl.formatMessage({id: 'MENU.TELEPHONY'})}
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      </SecuredComponent>

      {/* Domaines & DNS */}
      {!isSidebarItemHiddenForClientType('domainsDns', clientType) && (
        <SecuredComponent requiredPermissions={['voirEtatParc']}>
          <SidebarMenuItemWithSub
            to="/services/domaine/liste"
            title={intl.formatMessage({id: 'MENU.CLOUD.GROUP_DNS'})}
            childPaths={['/services/dns-zones', '/services/certificats', '/services/domaine/infos']}
            biIcon="bi-globe2"
          >
            <SidebarMenuItem
              to="/services/domaine/liste"
              title={intl.formatMessage({id: 'MENU.CLOUD.DOMAINS'})}
              activePaths={['/services/domaine/infos']}
              hasBullet={true}
            />
            <SidebarMenuItem
              to="/services/dns-zones"
              title={intl.formatMessage({id: 'MENU.CLOUD.DNS_ZONES'})}
              hasBullet={true}
            />
            <SidebarMenuItem
              to="/services/certificats"
              title={intl.formatMessage({id: 'MENU.CLOUD.CERTIFICATES'})}
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>
        </SecuredComponent>
      )}

      {/* Emails */}
      {!isSidebarItemHiddenForClientType('emails', clientType) && (
        <SecuredComponent requiredPermissions={['voirEtatParc']}>
          <SidebarMenuItemWithSub
            to="/services/messagerie"
            title={intl.formatMessage({id: 'MENU.CLOUD.GROUP_EMAILS'})}
            childPaths={['/services/messagerie', '/services/microsoft-mail', '/services/m365']}
            biIcon="bi-envelope"
          >
            <SidebarMenuItem
              to="/services/messagerie"
              title={intl.formatMessage({id: 'MENU.CLOUD.ZIMBRA'})}
              hasBullet={true}
            />
            <SidebarMenuItem
              to="/services/microsoft-mail"
              title={intl.formatMessage({id: 'MENU.CLOUD.MICROSOFT_MAIL'})}
              hasBullet={true}
            />
            <SidebarMenuItem
              to="/services/m365"
              title={intl.formatMessage({id: 'MENU.CLOUD.M365'})}
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>
        </SecuredComponent>
      )}

      {/* Web & bases de données */}
      {!isSidebarItemHiddenForClientType('webDatabase', clientType) && (
        <SecuredComponent requiredPermissions={['voirEtatParc']}>
          <SidebarMenuItemWithSub
            to="/services/database"
            title={intl.formatMessage({id: 'MENU.CLOUD.GROUP_WEB'})}
            childPaths={['/services/database', '/services/ftp', '/services/web-hebergement', '/services/wordpress']}
            biIcon="bi-server"
          >
            <SidebarMenuItem
              to="/services/database"
              title={intl.formatMessage({id: 'MENU.CLOUD.DATABASES'})}
              hasBullet={true}
            />
            <SidebarMenuItem
              to="/services/ftp"
              title={intl.formatMessage({id: 'MENU.CLOUD.FTP'})}
              hasBullet={true}
            />
            <SidebarMenuItem
              to="/services/web-hebergement"
              title={intl.formatMessage({id: 'MENU.CLOUD.HOSTING'})}
              hasBullet={true}
            />
            <SidebarMenuItem
              to="/services/wordpress"
              title={intl.formatMessage({id: 'MENU.CLOUD.WORDPRESS'})}
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>
        </SecuredComponent>
      )}

      {/* Infrastructure */}
      <SecuredComponent requiredPermissions={['voirEtatParc']}>
        <SidebarMenuItemWithSub
          to="/services/baies"
          title={intl.formatMessage({id: 'MENU.CLOUD.GROUP_INFRA'})}
          childPaths={['/services/baies', '/services/vms', '/services/vps', '/services/dedie']}
          biIcon="bi-building"
        >
          <SidebarMenuItem
            to="/services/baies"
            title={intl.formatMessage({id: 'MENU.CLOUD.BAYS'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to="/services/vms"
            title={intl.formatMessage({id: 'MENU.CLOUD.VMS'})}
            hasBullet={true}
          />
          {!isSidebarItemHiddenForClientType('infrastructureVps', clientType) && (
            <SidebarMenuItem
              to="/services/vps"
              title={intl.formatMessage({id: 'MENU.CLOUD.VPS'})}
              hasBullet={true}
            />
          )}
          {!isSidebarItemHiddenForClientType('infrastructureDedicated', clientType) && (
            <SidebarMenuItem
              to="/services/dedie"
              title={intl.formatMessage({id: 'MENU.CLOUD.DEDICATED'})}
              hasBullet={true}
            />
          )}
        </SidebarMenuItemWithSub>
      </SecuredComponent>

      <MenuSeparator />

      {/* Boutique en ligne */}
      <SecuredComponent requiredPermissions={[]}>
        <>
          {!isSidebarItemHiddenForClientType('marketplace', clientType) && (
            <SidebarMenuItem
              to="/marketplace"
              icon={iconMarketplace}
              title={intl.formatMessage({id: 'MENU.SHOP'})}
              fontIcon=""
              hisPng={true}
            />
          )}

          {!isSidebarItemHiddenForClientType('divops', clientType) && (
            <SidebarMenuItem
              to="/divops"
              biIcon="bi-diagram-3"
              title={intl.formatMessage({id: 'MENU.DIVOPS.ORDER'})}
              hasBullet={false}
              exact
              activePaths={['/divops/historique', '/divops/eligibilite-masse']}
            />
          )}

          {/* <SidebarMenuItemWithSub
              to="/divops"
              title={intl.formatMessage({id: 'MENU.DIVOPS'})}
              childPaths={['/divops']}
              biIcon="bi-telephone"
          >
            <SidebarMenuItem
                to="/divops/aps"
                title={intl.formatMessage({id: 'MENU.DIVOPS.COMMANDE'})}
                hasBullet={true}
            />

            <SidebarMenuItem
                to="/divops"
                title={intl.formatMessage({id: 'MENU.DIVOPS.ELIGIBILITE'})}
                hasBullet={true}
                exact
                activePaths={['/divops/historique', '/divops/eligibilite-masse']}
            />
          </SidebarMenuItemWithSub> */}
        </>
      </SecuredComponent>
    </>
  );
};

export {SidebarMenuMain};
